import getRuleSetByContextIds from 'services/api/personalizedPreviewPlacements/getRuleSetByContextIds';
import getRuleSetByContextId from 'services/api/personalizedPreviewPlacements/getRuleSetByContextId';
import getVariations from 'services/api/personalizedPreviewPlacements/getVariations';
import getRuleDetails from 'services/api/personalizedPreviewPlacements/getRuleDetails';

export default { getRuleSetByContextId, getRuleSetByContextIds, getVariations, getRuleDetails };
